module.exports = __webpack_public_path__ + "img/dutchmans-daiquiri.3439114a.jpg";